export default __webpack_public_path__ + "static/media/HR.3a587f7a.svg";